import type { FC } from 'react'

import { Select } from '@skytech/ui'
import { getEntries } from '@skytech/utils'

import { Translation } from '@/components/i18n/Translation'
import { useSearchParamsByKey } from '@/hooks/searchParams'
import { numberFormat } from '@/util/formatters/numbers'

import type { OrderStatusCount } from './resources'

export const StatusSelect: FC<{
  statusCounter: OrderStatusCount
}> = ({ statusCounter }) => {
  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status')

  const statusOptions = getEntries(statusCounter)
    .filter(([, counter]) => counter > 0)
    .map(([status, counter]) => {
      const parsedStatus = status === 'completed' ? 'done' : status
      return {
        value: parsedStatus,
        label: (
          <>
            <Translation id={`STATUS_SUBSCRIPTION_ORDER/${parsedStatus}`} />{' '}
            <b>{numberFormat(counter)}</b>
          </>
        ),
      }
    })
  return (
    <Select
      id="status-dropdown"
      className="flex capitalize md:hidden"
      marginBottom={18}
      value={queryStatus || ''}
      label={<Translation id="Select status" />}
      options={statusOptions}
      onChange={status => {
        if (!status) return
        if (typeof status.value !== 'string') throw Error('Incorrect status!')
        setQueryStatus(status.value)
      }}
    />
  )
}
